module.exports = __webpack_public_path__ + "img/newLogo.2864f3b8.png";